var _circle, _circle2, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUserProfileDefault2 = function SvgIcnUserProfileDefault2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 52.5,
    stroke: "#EDEDEE",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1962_116926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 90,
    height: 90
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 45,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1962_116926)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1962_116926)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 89.4203,
    height: 89.4203,
    fill: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9414 96.9229C18.9414 86.0112 22.8019 76.1138 29.0702 68.8652C31.753 65.7628 36.3896 66.2001 39.9183 68.2907C44.2515 70.8578 49.3088 72.3313 54.7104 72.3313C60.1122 72.3313 65.1699 70.8576 69.5032 68.2902C73.0318 66.1996 77.6685 65.7621 80.3514 68.8644C86.62 76.1132 90.4808 86.0108 90.4808 96.9229C90.4808 119.147 74.4661 137.164 54.7111 137.164C34.956 137.164 18.9414 119.147 18.9414 96.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.7104,
    cy: 48.6132,
    r: 16.2582,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1962_116926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.4203,
    height: 89.4203,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUserProfileDefault2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_user_profile_default2.07a88cbc.svg";
export { ForwardRef as ReactComponent };